// Firebase App (the core Firebase SDK) is always required and must be listed first
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, setPersistence, browserSessionPersistence } from "firebase/auth";
// import firebase from "firebase";
// import "firebase/auth";
// import "firebase/firestore";
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_ApiKey,
  authDomain: process.env.REACT_APP_FIREBASE_AuthDomain,
  databaseURL: process.env.REACT_APP_FIREBASE_DatabaseURL,
  projectId: process.env.REACT_APP_FIREBASE_ProjectId,
  storageBucket: process.env.REACT_APP_FIREBASE_StorageBucket,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MessagingSenderId,
  appId: process.env.REACT_APP_FIREBASE_AppId,
};
let firebaseApp = initializeApp(firebaseConfig);
let auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);

async function setPersistanceFirebase(auth) {
  if (auth) {
    await setPersistence(auth, browserSessionPersistence);
  }
}
setPersistanceFirebase(auth);

export { firebaseApp, auth, db };
